import { API_PUBLIC_HOST } from "@/_constant";
import api from "./request";

export function createStory(payload) {
    const url = `${API_PUBLIC_HOST}/userStory/createUserStory`;
    return api.post(url, payload);
}

export function updateStory(payload) {
    const url = `${API_PUBLIC_HOST}/userStory/updateUserStory`;
    return api.post(url, payload);
}

export function getStories(payload) {
    const url = `${API_PUBLIC_HOST}/userStory/viewAllUserStories`;
    return api.post(url, payload);
}

export function getStoryDetails(storyId) {
    const url = `${API_PUBLIC_HOST}/userStory/viewUserStoryById?userStoryId=${storyId}`
    return api.get(url);
}